import { useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-hot-toast';
import { cloneDeep } from 'lodash';
import styled, { css } from 'styled-components';
import DatePicker from "react-datepicker";
import Api from '../../utils/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/free-solid-svg-icons';

const styles = css`
display: flex;
flex-direction: column;
align-content: center;

> .title {
  font-size: 1.5em;
  font-weight: bold;
  padding-bottom: 20px;
  text-align: center;
}
> .form {
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  gap: 20px;
  padding: 30px;

  > textarea {
    resize: none;
  }

  > .recipients {
      display: flex;
      flex-direction: column;
      gap: 5px;
    > .add-recipient {
      display: grid;
      grid-template-columns: 40px auto;
      gap: 20px;
      align-items: center;
      > .button {
        font-size: 0.75em;
      }
      > .user {
        display: flex;
      }
    }
  }
  > .buttons { 
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
  }
}
`
const NewEvent = styled(({ className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { group } = state ?? {};

  const [name, setName] = useState('');
  const [date, setDate] = useState(new Date());
  const [eventLocation, setLocation] = useState('');
  const [notes, setNotes] = useState('');
  const [selected, setSelected] = useState(group?.members.reduce((res, member) => {
    res[member._id] = false;
    return res;
  }, {}));

  const isSubmitOk = (name !== '' && date !== null);

  const submit = async () => {
    if (isSubmitOk) {
      const recipients = Object.entries(selected)
        .reduce((res, [id, isSelected]) => {
          if (isSelected) {
            res.push(group.members.find(member => member._id === id));
          }
          return res;
        }, []);
      const [error,] = await Api.addEventToGroup(group._id, {
        name,
        date,
        recipients,
        location: eventLocation,
        notes
      });
      if (error) {
        toast.error(Api.error(error));
        console.error(error);
      } else {
        toast.success('Event added successfully');
        navigate(-1);
      }
    }
  }

  const toggleRecipient = member => {
    const newSelected = cloneDeep(selected);
    newSelected[member._id] = !newSelected[member._id];
    setSelected(newSelected);
  }

  const SelectMember = ({ member }) => {
    const buttonClass = selected[member._id] ? 'danger' : 'primary';
    const buttonIcon = selected[member._id] ? 'X' : <FontAwesomeIcon icon={faAdd} />;
    return (
      <div className='add-recipient'>
        <button className={buttonClass} onClick={() => toggleRecipient(member)}>
          {buttonIcon}
        </button>
        <div className='user'>
          <div>{`${member.firstname} ${member.lastname}`}</div>
        </div>
      </div>
    )
  }

  if (!group) return <div>No Group Provided</div>

  return (
    <div className={className}>
      <div className='title'>
        {`Add event for group "${group.name}"`}
      </div>
      <div className='form'>
        <input placeholder='Event Name (required)' value={name} onChange={e => setName(e.target.value)} />
        <DatePicker selected={date} onChange={(date) => setDate(date)} />
        <textarea placeholder='Event Location (optional)' value={eventLocation} onChange={e => setLocation(e.target.value)} />
        <textarea placeholder='Event Notes (optional)' value={notes} onChange={e => setNotes(e.target.value)} />
        <div className='recipients'>
          <div>
            Add recipients
          </div>
          {
            group.members.map(member => <SelectMember key={member._id} member={member} />)
          }
        </div>
        <div className='buttons'>
          <button className='danger' onClick={() => navigate(-1, { replace: true })}>Cancel</button>
          <button disabled={!isSubmitOk} className='primary' onClick={submit}>Save</button>
        </div>
      </div>
    </div>
  )
})`${styles}`;

export default NewEvent;